import { supabase } from '../src/lib/supabaseClient';
import { clearPasswordRecoveryHint } from './passwordRecoverySessionHint';

const DEDUPE_KEY = 'nemolight_recovery_token_verify_once';

/**
 * 邮件链接为「本站 ?token_hash=…&type=recovery」时（见 supabase/README.md 模板配置），
 * 在其它 auth 逻辑前调用，用 verifyOtp 换会话并清掉地址栏参数，避免邮件里出现 supabase.co。
 */
export async function consumeRecoveryQueryIfPresent(languageZh: boolean): Promise<void> {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  const token_hash = url.searchParams.get('token_hash');
  const type = url.searchParams.get('type');
  if (!token_hash || type !== 'recovery') return;

  const prev = sessionStorage.getItem(DEDUPE_KEY);
  if (prev === token_hash) return;
  sessionStorage.setItem(DEDUPE_KEY, token_hash);

  try {
    const { error } = await supabase.auth.verifyOtp({ type: 'recovery', token_hash });
    url.searchParams.delete('token_hash');
    url.searchParams.delete('type');
    const qs = url.searchParams.toString();
    window.history.replaceState({}, '', `${url.pathname}${qs ? `?${qs}` : ''}${url.hash}`);

    if (error) {
      sessionStorage.removeItem(DEDUPE_KEY);
      clearPasswordRecoveryHint();
      window.alert(
        languageZh
          ? '重置链接无效或已过期，请返回登录页重新申请「忘记密码」。'
          : 'This reset link is invalid or expired. Please request a new reset from the sign-in page.'
      );
    }
  } catch {
    sessionStorage.removeItem(DEDUPE_KEY);
    clearPasswordRecoveryHint();
  }
}
